module.exports = __webpack_public_path__ + "img/tool.6251ca9c.svg";